/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 16oTSa7DQBPEWCKQEY9DXA
// Component: PkxxjHWNrfMR

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGTimeFromNow } from "@lg-plus/landing-components"; // plasmic-import: cBv9_bke8T9e/codeComponent
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: 3syvFCgGv-uE/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicSliderForm.module.css"; // plasmic-import: PkxxjHWNrfMR/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: LJxmCpA6pqiN/icon
import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: LQrPrtzaKPRe/icon
import ChevronDown2Icon from "./icons/PlasmicIcon__ChevronDown2"; // plasmic-import: R68VorKcSj0E/icon

createPlasmicElementProxy;

export type PlasmicSliderForm__VariantMembers = {};
export type PlasmicSliderForm__VariantsArgs = {};
type VariantPropType = keyof PlasmicSliderForm__VariantsArgs;
export const PlasmicSliderForm__VariantProps = new Array<VariantPropType>();

export type PlasmicSliderForm__ArgsType = {
  slider?: React.ReactNode;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSliderForm__ArgsType;
export const PlasmicSliderForm__ArgProps = new Array<ArgPropType>(
  "slider",
  "children"
);

export type PlasmicSliderForm__OverridesType = {
  root?: Flex__<"div">;
  svg?: Flex__<"svg">;
  lgTimeFromNow?: Flex__<typeof LGTimeFromNow>;
};

export interface DefaultSliderFormProps {
  slider?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSliderForm__RenderFunc(props: {
  variants: PlasmicSliderForm__VariantsArgs;
  args: PlasmicSliderForm__ArgsType;
  overrides: PlasmicSliderForm__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $state.slider.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return 17000;
              }
              throw e;
            }
          })()
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_16oTSa7DQBPEWCKQEY9DXA",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__lv9BI)}>
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.slider
        })}
      </div>
      <div className={classNames("all", sty.freeBox___99Hj7)}>
        <div className={classNames("all", sty.freeBox__khEu)}>
          <IconIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames("all", sty.svg)}
            role={"img"}
          />
        </div>
        <div className={classNames("all", "__wab_text", sty.text___9EjzB)}>
          {"Peni\u0301ze na u\u0301c\u030ctu do"}
        </div>
        <LGTimeFromNow
          data-plasmic-name={"lgTimeFromNow"}
          data-plasmic-override={overrides.lgTimeFromNow}
          className={classNames("__wab_instance", sty.lgTimeFromNow)}
          offsetMinutes={15}
          placeholder={"--:--"}
          template={"{time}"}
        />
      </div>
      <div className={classNames("all", "__wab_text", sty.text__unkAi)}>
        {
          "Ide\u00e1ln\u00ed p\u016fj\u010dka na\u0161ich z\u00e1kazn\u00edk\u016f je 20 000 K\u010d v d\u00e9lce od 3 do 36 m\u011bs\u00edc\u016f, s \u00farokem 2,99 % p. a., Max. RPSN 4,39 %. M\u011bs\u00ed\u010dn\u00ed spl\u00e1tka 594 K\u010d. Celkem k zaplacen\u00ed 24 967 K\u010d. V\u00fdpo\u010det je pouze ilustrativn\u00ed, kone\u010dn\u00fd \u00farok ur\u010d\u00ed poskytovatel. "
        }
      </div>
      {renderPlasmicSlot({
        defaultContents: (
          <ButtonPrimary
            className={classNames("__wab_instance", sty.buttonPrimary__mv24K)}
            color={"neutral"}
            label={
              <div className={classNames("all", "__wab_text", sty.text__rmkyU)}>
                {"Z\u00cdSKAT PEN\u00cdZE"}
              </div>
            }
          />
        ),

        value: args.children
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg", "lgTimeFromNow"],
  svg: ["svg"],
  lgTimeFromNow: ["lgTimeFromNow"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
  lgTimeFromNow: typeof LGTimeFromNow;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSliderForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSliderForm__VariantsArgs;
    args?: PlasmicSliderForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSliderForm__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSliderForm__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSliderForm__ArgProps,
          internalVariantPropNames: PlasmicSliderForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSliderForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSliderForm";
  } else {
    func.displayName = `PlasmicSliderForm.${nodeName}`;
  }
  return func;
}

export const PlasmicSliderForm = Object.assign(
  // Top-level PlasmicSliderForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    lgTimeFromNow: makeNodeComponent("lgTimeFromNow"),

    // Metadata about props expected for PlasmicSliderForm
    internalVariantProps: PlasmicSliderForm__VariantProps,
    internalArgProps: PlasmicSliderForm__ArgProps
  }
);

export default PlasmicSliderForm;
/* prettier-ignore-end */
